module.exports = __webpack_public_path__ + "system/img/portrait.f57c3336.png";